var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate1 = function SvgTemplate1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 4H4C3.44772 4 3 4.44772 3 5V10C3 10.5523 3.44772 11 4 11H20C20.5523 11 21 10.5523 21 10V5C21 4.44772 20.5523 4 20 4Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20 13H4C3.44772 13 3 13.4477 3 14V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V14C21 13.4477 20.5523 13 20 13Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate1;